<template>
  <!-- 邀请弹框 -->
  <div class="invite-alert" @click="close">
    <van-dialog v-model="showPopup" :show-confirm-button="false" closeOnClickOverlay>
      <div class="alert-box">
        <div class="title">
          <div class="line"></div>推荐语<div class="line"></div>
        </div>
        <div class="content">{{ text }}</div>
        <div class="extend">
          <img src="@/assets/icons/checked_green.png" />
          <span>文案已复制，去粘贴吧！</span>
        </div>
        <img class="popup-arrow" src="@/assets/icons/arrow.png" />
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: 'sharePopup',
  props: {
    show: Boolean,
    text: {
      type: String,
      default: '点击右上角，喊好友一起学，96%的家长成功赚得奖学金，偷偷告诉你：上不封顶哦~'
    }
  },
  data() {
    return {
      showPopup: false
    }
  },
  watch: {
    show(value) {
      this.showPopup = value
      if (value) {
        console.log('copy', this.text)
        this.$copyText(this.text).then(res => {
          console.log('copy success', res)
        }).catch(err => {
          console.log('copy faild', err)
        })
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
  .invite-alert {
    .van-dialog{
      overflow: inherit;
    }
    .popup-arrow{
      position: fixed;
      top: -90px;
      right: 0;
      width: 62px;
      height: 75px;
      z-index: 99999;
    }
    .title {
      display: flex;
      justify-content: center;
      font-size: 28px;
      line-height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      color: #333;
      font-weight: bold;
      margin: 10px 0;
      .line {
        margin: 18px 20px;
        height: 2px;
        width: 50px;
        background: #2d3335;
      }
    }
    .content {
      margin: 0 15px;
      padding: 12px 17px;
      background: #f5f6f9;
      color: #666;
      line-height: 24px;
    }
    .extend {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 17px 0;
      img {
        height: 30px;
        display: block;
        margin-right: 6px;
      }
      span {
        font-size: 18px;
        color: #2d3335;
        font-weight: 500;
      }
    }
  }
</style>
